<app-employee-edit-widget
    [showHeader]="false"
    [hideUserDropdownLink]="true"
    [noBackToList]="true"
    [noSaveButton]="true"
    [modelId]="employeeModelId()"
    (detailEmployeeFormChange)="onEmployeeChange($event)"
/>
